import type { ApiRequest, ApiResponse, ApiTransport } from './transport';

/**
 * Базовый адрес API. На хостах *.shotbook.art — same-origin `/api`: nginx
 * отдаёт API на том же хосте, что и SPA, это снимает preflight и даёт работать
 * sendBeacon (TRK-1). Иначе — VITE_API_URL, нормализованный до `.../api`.
 */
export function resolveApiBaseUrl(configured: string, hostname: string, origin: string): string {
  if (/(^|\.)shotbook\.art$/.test(hostname)) return `${origin}/api`;

  let url = configured.trim();
  if (!/^https?:\/\//.test(url)) url = 'https://shotbook.art/api';
  if (url.endsWith('/')) url = url.slice(0, -1);
  if (!url.endsWith('/api')) url = `${url}/api`;
  return url;
}

export class LiveTransport implements ApiTransport {
  constructor(private readonly baseUrl: string) {}

  url(path: string): string {
    return `${this.baseUrl}${path.startsWith('/') ? path : `/${path}`}`;
  }

  async send(request: ApiRequest): Promise<ApiResponse> {
    const response = await fetch(this.url(request.path), {
      method: request.method,
      headers: request.headers,
      body:
        request.body === undefined
          ? undefined
          : typeof FormData !== 'undefined' && request.body instanceof FormData
            ? request.body
            : JSON.stringify(request.body),
      keepalive: request.keepalive,
      signal: request.signal,
    });

    if (response.status === 204) return { status: 204, body: null };

    const text = await response.text();
    let body: unknown = null;
    if (text) {
      try {
        body = JSON.parse(text);
      } catch {
        body = { message: text };
      }
    }
    return { status: response.status, body };
  }

  beacon(path: string, payload: unknown): boolean {
    try {
      if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
        const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
        return navigator.sendBeacon(this.url(path), blob);
      }
    } catch {
      // Переполненная очередь beacon — вызывающий упадёт в fetch keepalive.
    }
    return false;
  }
}
